<template>
  <div class="elencocomponentiimport">
    <b-container fluid>
      <b-row class="headerbox">
        <b-col>
          <h5>Importa Componenti</h5>
        </b-col>
      </b-row>
      <br>
      <form-wizard 
        title="" 
        subtitle=""
        nextButtonText="Avanti"
        backButtonText="Indietro"
        finishButtonText="Registrati"
        color="#493240"
        stepSize="xs"
        >
        <tab-content title="Tipologia" :before-change="step1">
          <b-row class="separatore_text">
            <b-col>
              <hr>
            </b-col>
            <b-col>
              <h5>SELEZIONA UNA TIPOLOGIA DI IMPORTAZIONE</h5>
            </b-col>
            <b-col>
              <hr>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="8" offset-md="2">
              <b-form-select class="slide-up" id="tipologia" v-model="formData.step1.tipologia" :options="option.tipologia" :state="state.step1.tipologia" placeholder="Tipologia di importazione" /><label for="tipologia">Tipologia*</label>
              <br>
              <br>
              <br>
            </b-col>
          </b-row>
        </tab-content>
        <tab-content title="Categorie" :before-change="step2">
          <b-row>
            <b-col>
              <b-table
                :striped="true"
                :hover="true"
                :responsive="true"
                :items="table.categorie.lista"
                :fields="table.categorie.campi"
                :current-page="table.categorie.currentPage"
                :per-page="table.categorie.perPage"
              >
                <template slot="tipocomponente" slot-scope="row">
                  <b-form-select v-model="row.item.tipocomponente" @change="getListaSottocomponente(row.index)" :state="state.idSottotipocomponente" :options="option.tipocomponente" placeholder="Seleziona una tipologia di componente" />
                </template>
                <template slot="sottotipocomponente" slot-scope="row">
                  <b-form-select v-if="refresh.sottocategoria" v-model="row.item.sottotipocomponente" :state="state.idSottotipocomponente" :options="option.sottotipocomponente[(table.categorie.currentPage-1)*table.categorie.perPage + row.index]" placeholder="Seleziona una sottotipologia di componente" />
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-pagination
                :total-rows="table.categorie.totalRows"
                :per-page="table.categorie.perPage"
                v-model="table.categorie.currentPage"
                align="center"
              />
            </b-col>
          </b-row>
        </tab-content>
        <tab-content title="Elementi" :before-change="fine">
          <b-row>
            <b-col>
              <b-table
                :striped="true"
                :hover="true"
                :responsive="true"
                :items="table.componenti.lista"
                :fields="table.componenti.campi"
                :current-page="table.componenti.currentPage"
                :per-page="table.componenti.perPage"
              >
                <template slot="attivo" slot-scope="row">
                  <b-form-checkbox v-model="row.item.attivo" :value="true" :unchecked-value="false"></b-form-checkbox>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-pagination
                :total-rows="table.componenti.totalRows"
                :per-page="table.componenti.perPage"
                v-model="table.componenti.currentPage"
                align="center"
              />
            </b-col>
          </b-row>
        </tab-content>
    </form-wizard>
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue'
import { constants } from 'crypto'

export default {
  name: 'elencocomponentiimport',
  data() {
    return {
      option:{
        tipologia: [],
        tipocomponente: [],
        sottotipocomponente: []
      },
      formData: {
        step1: {
          tipologia: null
        },
        step2: {
          categorie: []
        },
        step3:{
          componenti: []
        }
      },
      state: {
        step1: {
          tipologia: null
        }
      },
      table: {
        categorie: {
          lista: [],
          campi: [
            {key: 'catattuale', label: 'Categoria Attuale', sortable: true},
            {key: 'tipocomponente', label: 'Tipologia di Componente', sortable: true},
            {key: 'sottocatattuale', label: 'Sottocategoria Attuale', sortable: true},
            {key: 'sottotipocomponente', label: 'Sottotipologia di Componente', sortable: true}
          ],
          totalRows: 0,
          currentPage: 1,
          perPage: 10,
        },
        componenti: {
          lista: [],
          campi: [,
            {key: 'codcatalogo', label: 'Codice Catalogo', sortable: true},
            {key: 'descrizione', label: 'Descrizione', sortable: true},
            {key: 'tipocomponente', label: 'Tipologia di Componente', sortable: true},
            {key: 'sottotipocomponente', label: 'Sottotipologia di Componente', sortable: true},
            {key: 'attivo', label: '', sortable: true}
          ],
          totalRows: 0,
          currentPage: 1,
          perPage: 10,
        }
      },
      refresh: {
        sottocategoria: true
      }
    }
  },
  created: function(){
    this.listaTipologie()
  },
  methods: {
    step1(){
      return Vue.http.post('import/step1', {step1: this.formData.step1}, {credentials : true}).then(response => {
        if(response.body.success){
          this.option.tipocomponente = this.getListOption("componente")
          this.table.categorie.lista = response.body.list
          this.table.categorie.totalRows = this.table.categorie.lista.length

          for(var i=0; i<this.table.categorie.lista.length; i++){
            this.option.sottotipocomponente.push([])
          }

          return true
        }else{
          for(var i=0; i<Object.keys(this.state).length; i++){
            this.state.step1[Object.keys(this.state.step1)[i]] = null
          }

          for(var i=0; i<response.body.inputError.length; i++){
            this.state.step1[response.body.inputError[i]] = false
          }
          
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: response.body.msg,
              type: 'error'
          })
          return false
        }
      }, response => {})
    },
    step2(){
      this.formData.step2.categorie = this.table.categorie.lista
      return Vue.http.post('import/step2', {step1: this.formData.step1, step2: this.formData.step2}, {credentials : true}).then(response => {
        if(response.body.success){
          this.table.componenti.lista = response.body.list
          this.table.componenti.totalRows = this.table.componenti.lista.length

          return true
        }else{
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: response.body.msg,
              type: 'error'
          })
          return false
        }
      }, response => {})
    },
    fine(){
      this.formData.step3.componenti = this.table.componenti.lista
      return Vue.http.post('import/step3', this.formData, {credentials : true}).then(response => {
        if(response.body.success){
          Vue.notify({
            group: 'global',
            title: 'Operazione riuscita!',
            text: 'Componenti importati con successo!',
            type: 'success'
          })
          this.$router.push('/elenco/componenti')
          return true
        }else{
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: response.body.msg,
              type: 'error'
          })
          return false
        }
      }, response => {})
    },

    getListOption(tipo){
      var list = []

      Vue.http.post('selectlist/'+tipo, {}, {credentials : true}).then(response => {
        if(response.body.success){
            for(var i=0; i<response.body.list.length; i++){
              if(response.body.list[i].codice)
                list.push({value: response.body.list[i].id, text: response.body.list[i].codice+" - "+response.body.list[i].nome})
              else
                list.push({value: response.body.list[i].id, text: response.body.list[i].nome})
            }
        }else{
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: "Lista "+tipo+" non caricata correttamente.",
              type: 'error'
          })
        }
      }, response => {
        Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Lista "+tipo+" non caricata correttamente.",
            type: 'error'
        })
      })

      return list
    },
    listaTipologie(){
      Vue.http.post('import/lista', {}, {credentials : true}).then(response => {
        if(response.body.success){
          this.option.tipologia = response.body.list.map(e => {
            var ne = {}
            ne.text = e.nome
            ne.value = e.id
            ne.file = e.file

            return ne
          })
        }else{
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: "Lista Tipologie di Importazioni non caricata correttamente!",
              type: 'error'
          })
        }
      }, response => {})
    },

    getListaSottocomponente(index){
      var list = []

      index = (this.table.categorie.currentPage-1)*this.table.categorie.perPage + index

      if(this.table.categorie.lista[index].tipocomponente)
        this.option.sottotipocomponente[index] = this.getListOption("sottotipocomponente/"+this.table.categorie.lista[index].tipocomponente)

      var self = this
      this.refresh.sottocategoria = false
      setTimeout(function() {
        self.refresh.sottocategoria = true
      }, 200)
      
      return list
    }
  }
}
</script>

<style scoped>
#tipologia{
  text-indent: 105px;
}
</style>